import axios from 'axios'
import UserServices from '@/services/UserServices'
import { axiosErrorHandler, axiosSuccessHandler } from '@/plugins/axiosHandlers'
import ConvertToken from '@/utils/ConvertToken'

export default {
  namespaced: true,
  state: () => ({
    user: null,
    userId: '',
    account: {
      email: '',
      nombres: '',
      paterno: '',
      materno: '',
      tipoSuscripcion: '',
      rfc: ''
    },
  }),
  mutations: {
    SET_USER_DATA(state, userData) {
      state.user = userData
      axios.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${userData.access_token}`
      axios.defaults.headers.common[
        'x-api-key'
      ] = `${process.env.VUE_APP_API_PRIMARY_API_KEY}`
      axios.defaults.headers.common['Content-Type'] = 'application/json'
      axios.defaults.headers.common['Accept'] = 'application/json'
      axios.interceptors.response.use(
        response => axiosSuccessHandler(response),
        error => axiosErrorHandler(error)
      )

      const convert = new ConvertToken()
      state.userId = convert.parseJwt(userData.access_token).identity.userId
    },
    CLEAR_USER_DATA(state) {
      state.user = null
      state.userId = ''
      localStorage.removeItem('user')
      //location.reload()
    },
    SET_ACCOUNT_DATA(state, accountData) {
      state.account.email = accountData.email
      state.account.nombres = accountData.nombres
      state.account.paterno = accountData.paterno
      state.account.materno = accountData.materno
      state.account.tipoSuscripcion = accountData.tipoSuscripcion
      state.account.rfc = accountData.rfc
    }
  },
  actions: {
    login({ commit }, credentials) {
      const service = new UserServices()

      return service.signin(credentials).then(({ data }) => {
        const userData = data.data
        commit('SET_USER_DATA', userData)
        localStorage.setItem('user', JSON.stringify(userData))
      })
    },
    checkFirmaAccountWithIdentityToken({ commit }, token) {
      const service = new UserServices()

      return service.signinIdentity(token).then(({ data }) => {
        const userData = data.data
        commit('SET_USER_DATA', userData)
        localStorage.setItem('user', JSON.stringify(userData))
      })
    },
    async signup({ commit }, data) {
      const service = new UserServices()

      try {
        let respuesta = await service.signup(data)
        let retval = respuesta.data
        if (retval.success) {
          const userData = retval.data
          commit('SET_USER_DATA', userData)
          localStorage.setItem('user', JSON.stringify(userData))
        }

        return retval
      } catch (err) {
        const errorData = JSON.parse(err.request.response).error
        return {
          success: false,
          error: errorData
        }
      }
    },
    setUser({ commit }, userData) {
      commit('SET_USER_DATA', userData)
    },
    logout({ commit }) {
      commit('CLEAR_USER_DATA')
    },
    updateAccount({ commit, state }, userData) {
      const service = new UserServices()
      return service
        .editAccount(state.userId, userData)
        .then(({ data }) => {
          if (data.success) {
            commit('SET_ACCOUNT_DATA', {
              email: state.account.email,
              nombres: userData.nombres,
              paterno: userData.paterno,
              materno: userData.materno,
              tipoSuscripcion: userData.tipoSuscripcion
            })
          }
          return data
        })
        .catch(err => {
          return err.response
        })
    },
    getAccount({ commit, state }) {
      const service = new UserServices()
      return service.getAccount(state.userId).then(({ data }) => {
        commit('SET_ACCOUNT_DATA', {
          email: data.data.correo_electronico,
          nombres: data.data.nombres,
          paterno: data.data.paterno,
          materno: data.data.materno,
          tipoSuscripcion: data.data.tipo_suscripcion,
          rfc: data.data.rfc.rfc
        })
      })
    },
    checkIdentityAccount({commit, state}, code){
      const service = new UserServices()
      return service.checkIdentityAccount(code)
    }
  },
  getters: {
    loggedIn(state) {
      return !!state.user
    },
    userData(state) {
      return state.user
    },
    accountData(state) {
      return state.account
    },
    userId(state) {
      return state.userId
    },
    identidadesSingin(state){
      return `${process.env.VUE_APP_IDENTIDADES_URL}/${process.env.VUE_APP_IDENTIDADES_AUTH}&prompt=login&response_type=${process.env.VUE_APP_IDENTIDADES_RESPONSE}&client_id=${process.env.VUE_APP_IDENTIDADES_CLIENT_ID}&scope=${encodeURIComponent(process.env.VUE_APP_IDENTIDADES_SCOPE)}&redirect_uri=${encodeURIComponent(process.env.VUE_APP_IDENTIDADES_REDIRECT_LOGIN)}`
    },
    identidadesPasswordRecovery(state){
      return `${process.env.VUE_APP_IDENTIDADES_URL}/${process.env.VUE_APP_IDENTIDADES_PASS_RESET}&prompt=login&response_type=${process.env.VUE_APP_IDENTIDADES_RESPONSE}&client_id=${process.env.VUE_APP_IDENTIDADES_CLIENT_ID}&scope=${encodeURIComponent(process.env.VUE_APP_IDENTIDADES_SCOPE)}&redirect_uri=${encodeURIComponent(process.env.VUE_APP_IDENTIDADES_REDIRECT_LOGIN)}`
    },
    catchPassReset(state){
      return `${process.env.VUE_APP_IDENTIDADES_CATCH_PASS_RESET}`
    },
    catchCancelPassReset(state){
      return `${process.env.VUE_APP_IDENTIDADES_CATCH_CANCEL_PASS_RESET}`
    },
  }
}
